/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'ordered-grid';
const prefix = `${moduleName}.${componentName}`;

export const addRuleBtnLabel = `${prefix}.addRuleBtnLabel`;
export const emptyItemsFoundMessage = `${prefix}.emptyItemsFoundMessage`;

export const ENGLISH = {
    [addRuleBtnLabel]: 'Add rule',
    [emptyItemsFoundMessage]: 'No items found.',
};
